module.exports = __webpack_public_path__ + "static/aca_fct1-ec499d83292e68cbd458e98c5dfbed1b.jpg";